webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routing = __webpack_require__(29);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(71);
	
	var VueResource = __webpack_require__(86);
	
	_vue2.default.use(VueResource);
	
	var app = new _vue2.default({
	  router: _routing2.default
	}).$mount('#app');
	
	window.router = _routing2.default;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(31)
	
	/* template */
	var __vue_template__ = __webpack_require__(80)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(87);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _home = __webpack_require__(78);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/', component: _home2.default, name: 'home' }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});
	
	router.beforeEach(function (to, from, next) {
	  window.scrollTo(0, 0);
	  next();
	});
	
	exports.default = router;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(38);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _papaparse = __webpack_require__(72);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _Info = __webpack_require__(28);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _SmtpInfo = __webpack_require__(76);
	
	var _SmtpInfo2 = _interopRequireDefault(_SmtpInfo);
	
	var _Verify = __webpack_require__(77);
	
	var _Verify2 = _interopRequireDefault(_Verify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Info: _Info2.default,
	    SmtpInfo: _SmtpInfo2.default,
	    Verify: _Verify2.default
	  },
	  data: function data() {
	    return {
	      numAvailable: localStorage.getItem('numAvailable') ? localStorage.getItem('numAvailable') : 100,
	      file: '',
	      hovering: false,
	      rows: [],
	      cols: ['Salutation', 'First Name', 'Last Name', 'Email', 'Age', 'Gender'],
	      subject: 'Your Subject Here',
	      text: 'Dear {first-name},\n\nEnter your email text here as you would normally.\n\nYou can add variables by clicking on the column headers to the right. These will be replaced by the value in each row when you click send.\n\nClick on a row to preview how the email willl look..\n\nThank you\n\nYour Name',
	      currentRow: ['mr', 'tom', 'smith', 'tom.smith@email.com', 14, 'M', 'Elementary School'],
	      emailColumn: null,
	      edit: false,
	      step: 0,
	      numEmailCol: 0,
	      noEmailFound: false,
	      emailCols: [],
	      token: '',
	      errors: [],
	      msg: '',
	      loading: false,
	      sending: false,
	      email: ''
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var url = ("https://www.csv2email.com") + '/api/token/';
	    _vue2.default.http.get(url).then(function (data) {
	      _vue2.default.http.headers.common['X-CSRFToken'] = data.body.token;
	      _this.token = data.body.token;
	    }, function (error) {
	      console.log(error);
	    });
	  },
	
	  watch: {
	    text: function text(newValue) {
	      if (newValue !== this.text) {
	        this.step = 2;
	      }
	    }
	  },
	  computed: {
	    formatObj: function formatObj() {
	      var _this2 = this;
	
	      var formatObj = [];
	      var counter = 0;
	
	      this.cols.forEach(function (value) {
	        formatObj[_this2.slugify(value)] = _this2.currentRow[counter];
	        counter += 1;
	      });
	      return formatObj;
	    },
	    currentText: function currentText() {
	      return this.format(this.text, this.formatObj).replace(/\n/g, '<br />');
	    },
	    currentSubject: function currentSubject() {
	      return this.format(this.subject, this.formatObj);
	    },
	    currentEmail: function currentEmail() {
	      var index = this.cols.indexOf(this.emailColumn);
	      return this.currentRow[index];
	    },
	    getProgress: function getProgress() {
	      return "width: " + this.step * 25 + "%";
	    },
	    selectCols: function selectCols() {
	      return this.emailCols.length > 1 ? this.emailCols : this.cols;
	    }
	  },
	  methods: {
	    setStep: function setStep(step) {
	      this.step = step;
	    },
	    catchError: function catchError(error) {
	      this.errors = [error];
	      this.loading = false;
	    },
	    setEmail: function setEmail(email) {
	      this.step = 1;
	      this.email = email;
	    },
	    sendEmail: function sendEmail(smtp) {
	      var _this3 = this;
	
	      var rows = [];
	      var data = {};
	      this.sending = true;
	      this.rows.forEach(function (item) {
	        _this3.currentRow = item;
	        rows.push({
	          subject: _this3.currentSubject,
	          text: _this3.currentText.replace(/<br \/>/g, '\n'),
	          email: _this3.currentEmail
	        });
	      });
	      data.smtp = smtp;
	      data.rows = rows;
	      data.csrfmiddlewaretoken = this.token;
	      var url = ("https://www.csv2email.com") + '/api/send-email/';
	      this.loading = true;
	      _vue2.default.http.post(url, data).then(function (response) {
	        if (response.body.success) {
	          _this3.msg = response.body.msg;
	          if (!smtp.test) {
	            _this3.step = 4;
	          }
	          _this3.numAvailable -= _this3.rows.length;
	          localStorage.setItem('numAvailable', _this3.numAvailable);
	          ga('send', 'event', 'CSV', 'Send', _this3.rows.length);
	        }
	      }, function (response) {
	        _this3.errors = response.body.errors;
	        _this3.loading = false;
	      }).finally(function () {
	        _this3.sending = false;
	      });
	    },
	    toggleEdit: function toggleEdit(state) {
	      this.edit = state || !this.edit;
	      this.step = 3;
	      ga('send', 'event', 'CSV', 'Edit', 'text');
	    },
	    setEmailColum: function setEmailColum(col) {
	      this.emailColumn = col;
	      this.step = 1;
	      ga('send', 'event', 'CSV', 'Edit', 'header');
	    },
	    addVariable: function addVariable(value) {
	      var el = document.getElementById('editText');
	      var val = '{' + this.slugify(value) + '}';
	      var start = void 0;
	      var end = void 0;
	
	      if (el && el.selectionStart) {
	        start = el.selectionStart;
	        end = el.selectionEnd;
	        if (!end) {
	          end = start;
	        }
	
	        this.text = this.text.substring(0, start) + val + this.text.substring(end);
	        this.edit = true;
	      } else {
	        this.text += '\n' + val;
	      }
	      this.step = 3;
	      ga('send', 'event', 'CSV', 'Edit', 'variable');
	    },
	    slugify: function slugify(value) {
	      return value.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	    },
	    onFileChange: function onFileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.createFile(files[0]);
	    },
	    createFile: function createFile(file) {
	      var self = this;
	      this.file = file;
	      this.emailCols = [];
	
	      _papaparse2.default.parse(file, {
	        complete: function complete(rows) {
	          self.numEmailCol = 0;
	          self.rows = rows.data.splice(1, rows.data.length - 2);
	          if (self.rows.length > self.numAvailable) {
	            self.rows = [];
	            self.file = false;
	            alert('This CSV contains more rows than your monthly allowance. You Have ' + self.numAvailable + ' left');
	            return false;
	          }
	          self.currentRow = self.rows[0];
	          self.cols = rows.data[0];
	          self.emailColumn = null;
	          self.noEmailFound = false;
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(self.cols), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var col = _step.value;
	
	              if (col.toLowerCase().indexOf('email') > -1) {
	                self.emailColumn = col;
	                self.emailCols.push(col);
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (!self.emailColumn) {
	            self.noEmailFound = true;
	          }
	
	          if (self.emailCols.length > 1) {
	            self.noEmailFound = true;
	          }
	
	          if (self.noEmailFound) {
	            self.emailColumn = false;
	            self.step = 1;
	          } else {
	            self.step = 2;
	          }
	          ga('send', 'event', 'CSV', 'Upload', self.rows.length);
	          return true;
	        }
	      });
	    },
	    removeFile: function removeFile() {
	      console.log('called');
	      this.file = '';
	      this.step = 1;
	    },
	    format: function format(str, formatObj) {
	      var key = void 0;
	      var value = void 0;
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(formatObj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          key = _step2.value;
	
	          value = formatObj[key];
	
	          str = str.replace(RegExp("\\{" + key + "\\}", "gi"), value);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return str;
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'site-footer',
	
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	
	  methods: {},
	  directives: {}
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'site-header',
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	
	  methods: {},
	  directives: {}
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Info = __webpack_require__(28);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    info: _Info2.default
	  },
	  props: ['errors', 'numAvailable', 'sending', 'email'],
	  data: function data() {
	    return {
	      smtp: {
	        username: this.email,
	        test: true
	      }
	    };
	  },
	
	  methods: {
	    send: function send() {
	      this.$emit('sendemail', this.smtp);
	    }
	  }
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      email: '',
	      verifiedEmail: -1,
	      verifyCode: '',
	      userId: 0,
	      loading: false,
	      errors: []
	    };
	  },
	
	  computed: {
	    isValid: function isValid() {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return !this.loading && re.test(this.email);
	    }
	  },
	  methods: {
	    createOrVerify: function createOrVerify() {
	      var _this = this;
	
	      var url = ("https://www.csv2email.com") + '/api/email/';
	      this.loading = true;
	      this.$http.post(url, { email: this.email }).then(function (response) {
	        _this.loading = false;
	        _this.userId = response.body.pk;
	        if (!response.body.verified) {
	          _this.verifiedEmail = 0;
	        } else {
	          _this.verifiedEmail = 1;
	          _this.$emit('setemail', _this.email);
	        }
	      });
	    },
	    verify: function verify() {
	      var _this2 = this;
	
	      var url = ("https://www.csv2email.com") + '/api/email/' + this.userId + '/verify/';
	      this.loading = true;
	      var data = {
	        code: this.verifyCode,
	        email: this.email
	      };
	      this.$http.post(url, data).then(function () {
	        _this2.verifiedEmail = 1;
	        _this2.$emit('setemail', _this2.email);
	      }, function () {
	        _this2.errors = ['Invalid code. Please check your email and try again'];
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SiteHeader = __webpack_require__(75);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _SiteFooter = __webpack_require__(74);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	var _FileUpload = __webpack_require__(73);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    SiteFooter: _SiteFooter2.default,
	    FileUpload: _FileUpload2.default
	  }
	};

/***/ },
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 69 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(69)
	
	/* script */
	__vue_exports__ = __webpack_require__(30)
	
	/* template */
	var __vue_template__ = __webpack_require__(79)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-21610219"
	
	module.exports = __vue_exports__


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(82)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(84)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(85)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(70)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(81)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2be2abf5"
	
	module.exports = __vue_exports__


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(83)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row",
	    class: {
	      hide: _vm.step > 0
	    },
	    attrs: {
	      "id": "intro"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h2', {
	    staticClass: "h1"
	  }, [_vm._v("Send emails to recipients via CSV")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Verify your email")]), _vm._v(" "), _c('li', [_vm._v("Upload CSV")]), _vm._v(" "), _c('li', [_vm._v("Copy and Paste or write your email text")]), _vm._v(" "), _c('li', [_vm._v("Add variables from your CSV columns")]), _vm._v(" "), _c('li', [_vm._v("Send to all recipients")]), _vm._v(" "), _c('li', [_vm._v("You may send " + _vm._s(_vm.numAvailable) + " emails")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.step > 0) ? _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar bg-success",
	    style: (_vm.getProgress),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": "0",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    class: {
	      'success': _vm.step > 0
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    class: _vm.step < 0 ? 'col-md-8' : 'col-md-7'
	  }, [_c('verify', {
	    on: {
	      "step": _vm.setStep,
	      "setemail": _vm.setEmail
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    class: _vm.step > 0 ? 'col-md-1' : 'hidden'
	  }, [(_vm.step > 0) ? _c('i', {
	    staticClass: "fa fa-check pull-right fa-large"
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    class: {
	      'success': _vm.step > 1
	    }
	  }, [_vm._m(2), _vm._v(" "), (_vm.file.name) ? _c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v("\n      " + _vm._s(_vm.file.name) + " "), _c('i', {
	    staticClass: "fa fa-trash-o",
	    on: {
	      "click": _vm.removeFile
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [(_vm.step > 1) ? _c('i', {
	    staticClass: "fa fa-check pull-right fa-larger pull-right"
	  }) : _vm._e()])]), _vm._v(" "), (_vm.step == 1) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', [_c('div', {
	    staticClass: "dropzone-area",
	    class: {
	      'dropzone-hover': _vm.hovering
	    },
	    on: {
	      "dragenter": function($event) {
	        _vm.hovering = true
	      },
	      "dragleave": function($event) {
	        _vm.hovering = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dropzone-text"
	  }, [_c('span', {
	    staticClass: "dropzone-title"
	  }, [_vm._v("Drop CSV here or click to select")]), _vm._v(" "), (_vm.info) ? _c('span', {
	    staticClass: "dropzone-info"
	  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e()]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.onFileChange
	    }
	  })])]), _vm._v(" "), (_vm.noEmailFound && !_vm.emailColumn) ? _c('div', {
	    staticClass: "alert alert-warning padded tcenter margined"
	  }, [(_vm.emailCols.length > 1) ? _c('div', [_vm._v("\n          More than one column header included the word email, please select which one you want to use.\n        ")]) : _c('div', [_vm._v("\n          No Email column was found. You must have the keyword \"email\" in one column header. Please select one or upload a new CSV.\n        ")]), _vm._v(" "), _c('ul', {
	    staticClass: "select-email"
	  }, _vm._l((_vm.selectCols), function(col) {
	    return _c('li', {
	      staticClass: "cols",
	      on: {
	        "click": function($event) {
	          _vm.setEmailColum(col)
	        }
	      }
	    }, [_vm._v(_vm._s(col) + " "), _c('i', {
	      staticClass: "fa fa-check"
	    })])
	  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    class: {
	      'success': _vm.step > 2
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [(_vm.step > 2) ? _c('i', {
	    staticClass: "fa fa-check pull-right"
	  }) : _vm._e()])]), _vm._v(" "), (_vm.step > 1 && _vm.step < 4) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "text"
	  }, [_c('h5', [_vm._v("Live Preview "), _c('button', {
	    staticClass: "pull-right",
	    on: {
	      "click": function($event) {
	        _vm.toggleEdit()
	      }
	    }
	  }, [_vm._v("Edit "), _c('span', [_c('i', {
	    staticClass: "fa",
	    class: {
	      'fa-pencil-square-o': !_vm.edit, 'fa-pencil-square': _vm.edit
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v("From:  " + _vm._s(_vm.email))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v("To: " + _vm._s(_vm.currentEmail))]), _vm._v(" "), (!_vm.edit) ? _c('div', {
	    staticClass: "col-md-12",
	    on: {
	      "click": function($event) {
	        _vm.edit = true
	      }
	    }
	  }, [_vm._v("Subject: " + _vm._s(_vm.currentSubject))]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subject),
	      expression: "subject"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "placeholder": "Your Subject"
	    },
	    domProps: {
	      "value": _vm._s(_vm.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subject = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('div', {
	    staticClass: "current-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.currentText)
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleEdit(true)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text),
	      expression: "text"
	    }],
	    attrs: {
	      "id": "editText"
	    },
	    domProps: {
	      "value": _vm._s(_vm.text)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text = $event.target.value
	      }
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 table-holder"
	  }, [_c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('info'), _vm._v("Click on a column header to add the variable to your email text.\n      ")], 1), _vm._v(" "), _c('table', {
	    staticClass: "table table-hover table-border"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.cols), function(col) {
	    return _c('th', {
	      on: {
	        "click": function($event) {
	          _vm.addVariable(col)
	        }
	      }
	    }, [_vm._v(_vm._s(col) + "\n            ")])
	  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
	    return _c('tr', {
	      class: {
	        'selected': row == _vm.currentRow
	      },
	      on: {
	        "click": function($event) {
	          _vm.currentRow = row;
	          _vm.edit = false
	        }
	      }
	    }, _vm._l((row), function(col) {
	      return _c('td', [_vm._v(_vm._s(col))])
	    }))
	  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    class: {
	      'success': _vm.step == 4
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [(_vm.step > 2 && _vm.step < 4) ? _c('smtp-info', {
	    attrs: {
	      "sending": _vm.sending,
	      "errors": _vm.errors,
	      "num-available": _vm.numAvailable,
	      "email": _vm.email
	    },
	    on: {
	      "error": _vm.catchError,
	      "sendemail": _vm.sendEmail
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-1"
	  }, [(_vm.step > 3) ? _c('i', {
	    staticClass: "fa fa-check pull-right"
	  }) : _vm._e()])]), _vm._v(" "), (_vm.msg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h1', [_vm._v("CSV 2 Email")]), _vm._v("\n        Have a spreadsheet with emails that you'd like to send the same templated message to? With this tool you can\n        easily send emails everyone to in your spreadsheet, and add variables to your text. These variables will be\n        replaced by the values in each row. If you have a column named Order No, then you can put that into your email\n        wherever you want it with the text {order-no}. Ex: Your order #{order-no} was successfully received.\n    ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h3', [_vm._v("Step 1. Verify your email")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('h3', {
	    staticClass: "pull-left"
	  }, [_vm._v("Step 2. Upload CSV ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-11"
	  }, [_c('h3', [_vm._v("Step 3. Update Email Text")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('h3', [_vm._v("Step 4. Send")])])
	}]}

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "fa-stack fa-sm"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-info fa-stack-1x fa-inverse"
	  })])
	}]}

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "form-inline"
	  }, [(_vm.errors.length > 0) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('ul', _vm._l((_vm.errors), function(error) {
	    return _c('li', [_vm._v(_vm._s(error))])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail != 1) ? _c('div', {
	    staticClass: "input-group mr-sm-2 mb-sm-0"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("@")]), _vm._v(" "), (_vm.verifiedEmail == -1) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "john.smith@gmail.com"
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == 0) ? _c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.verifyCode),
	      expression: "verifyCode"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Verify Code"
	    },
	    domProps: {
	      "value": _vm._s(_vm.verifyCode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.verifyCode = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !_vm.isValid,
	      "value": "send"
	    },
	    on: {
	      "click": function($event) {
	        _vm.verify()
	      }
	    }
	  }, [(_vm.loading) ? _c('i', {
	    staticClass: "fa fa-spin fa-spinner"
	  }) : _vm._e(), _vm._v("\n            Verify " + _vm._s(_vm.email) + "\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == 1) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.email) + " (verified)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == -1) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !_vm.isValid,
	      "value": "send"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createOrVerify()
	      }
	    }
	  }, [(_vm.loading) ? _c('i', {
	    staticClass: "fa fa-spin fa-spinner"
	  }) : _vm._e(), _vm._v("\n    Verify Your Email\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "site-footer"
	  })
	},staticRenderFns: []}

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page"
	  }, [_c('site-header'), _vm._v(" "), _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('file-upload')], 1), _vm._v(" "), _c('site-footer')], 1)
	},staticRenderFns: []}

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
	  }, [_c('a', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("CSV 2 Email")]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_vm._v("Easily send hundreds of mails via CSV")])])
	}]}

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('label', {
	    attrs: {
	      "for": "id_test"
	    }
	  }, [_vm._v("Send Test emails to yourself?")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.smtp.test),
	      expression: "smtp.test"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "id_test"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.smtp.test) ? _vm._i(_vm.smtp.test, null) > -1 : (_vm.smtp.test)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.smtp.test,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.smtp.test = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.smtp.test = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.smtp.test = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "value": "send"
	    },
	    on: {
	      "click": function($event) {
	        _vm.send()
	      }
	    }
	  }, [(_vm.sending) ? _c('i', {
	    staticClass: "fa fa-spin fa-spinner"
	  }) : _vm._e(), _vm._v(" "), (_vm.smtp.test) ? _c('span', [_vm._v("Send Test")]) : _c('span', [_vm._v("Send to recipients")])])])])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.d17d611894ab00b6dedd.js